var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',[_c('entity-properties-row',{attrs:{"label":_vm.$t('corporation.name'),"property":_vm.corporation.name}}),_c('entity-properties-row',{attrs:{"label":_vm.$t('corporation.allowCsvExportTableHeader'),"property":_vm._f("yesNo")(_vm.corporation.allowCsvExport)}}),_vm._t("append")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }